export default __webpack_public_path__ + "static/banner_1_0-1f51b0881cb18010206d2636cb615118.jpg";